// scss

// import '@/assets/scss/app.scss'
// import '@/assets/C2F.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/js/bootstrap.js'
import '@/assets/scss/style.css'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import commonJs from './assets/js/common.js'
import PageList from './components/PageList'
import questionnaire from './components/Questionnaire'
import Chart from './components/Chart'
// import AOS animate
import AOS from 'aos';
import 'aos/dist/aos.css';



Vue.config.productionTip = false
Vue.prototype.common = commonJs;
Vue.prototype.downloadUrl = 'https://www.tac.com.tw/JsonFile/';
Vue.prototype.apiUrl = 'https://www.tac.com.tw/';  // 正式機
 

// Vue.prototype.apiUrl = 'http://10.0.105.112:8284/';   // 測試機測試
// Vue.prototype.PageComponents = PageList;
// 列表需呈現幾筆資料
Vue.prototype.listCount = 10;
// PageList需呈現正負幾頁(1=>三頁、2=>五頁 ...以此類推)
Vue.prototype.pageCount = 2;
/* eslint-disable no-new */
// AOS animate
Vue.component('AOS', AOS);
AOS.init({
    once: true
});

Vue.component('pageList', PageList)

// 利害關係人問卷
Vue.component('questionnaire', questionnaire)
Vue.component('Chart', Chart)

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js